import { render, staticRenderFns } from "./ViqUpsellJurisdictions.vue?vue&type=template&id=7021e753&scoped=true"
import script from "./ViqUpsellJurisdictions.vue?vue&type=script&lang=js"
export * from "./ViqUpsellJurisdictions.vue?vue&type=script&lang=js"
import style0 from "./ViqUpsellJurisdictions.vue?vue&type=style&index=0&id=7021e753&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7021e753",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7021e753')) {
      api.createRecord('7021e753', component.options)
    } else {
      api.reload('7021e753', component.options)
    }
    module.hot.accept("./ViqUpsellJurisdictions.vue?vue&type=template&id=7021e753&scoped=true", function () {
      api.rerender('7021e753', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqUpsellJurisdictions.vue"
export default component.exports